(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5999],{

/***/ 58787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ FaTimesCircle; }
/* harmony export */ });
/* harmony import */ var _iconBase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98851);

function FaTimesCircle(props) {
  return (0,_iconBase__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w)({
    "tag": "svg",
    "attr": {
      "viewBox": "0 0 512 512"
    },
    "child": [{
      "tag": "path",
      "attr": {
        "d": "M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z"
      }
    }]
  })(props);
}
;

/***/ }),

/***/ 43200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(40037);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91164);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var common_lodash_keyExistsOn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15438);
/* harmony import */ var components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59699);
/* harmony import */ var components_atoms_Icon_fa_FaTimesCircle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58787);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["data", "emi", "description", "thead"];








var renderCheck = function renderCheck(check) {
  return check ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("td", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Icon_fa_FaCheckCircle__WEBPACK_IMPORTED_MODULE_1__/* .FaCheckCircle */ .F, {
      className: "m-auto text-bbc-brand-600",
      size: 16
    })
  }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("td", {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(components_atoms_Icon_fa_FaTimesCircle__WEBPACK_IMPORTED_MODULE_2__/* .FaTimesCircle */ .G, {
      className: "m-auto text-bbc-red-400",
      size: 16
    })
  });
};

var TdBody = function TdBody(_ref) {
  var tableItem = _ref.tableItem,
      emi = _ref.emi;

  if (tableItem.contact_us) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("td", {
      colSpan: "5",
      className: "text-center",
      children: "Contact us for details"
    });
  }

  if (emi) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
      children: [renderCheck(tableItem.online_registration), renderCheck(tableItem.multiple_account), renderCheck(tableItem.support_transactions), renderCheck(tableItem.physical_card), tableItem.other_features && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
        children: typeof tableItem.other_features === "boolean" ? renderCheck(tableItem.other_features) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("td", {
          className: "px-4",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
            className: "block text-center",
            children: tableItem.other_features
          }), " "]
        })
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: [renderCheck(tableItem.online_banking), renderCheck(tableItem.personal_visit), renderCheck(tableItem.credit_card), renderCheck(tableItem.debit_card), tableItem.initial_deposit && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
      children: typeof tableItem.initial_deposit === "boolean" ? renderCheck(tableItem.initial_deposit) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("td", {
        className: "px-4",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
          className: "block text-center",
          children: tableItem.initial_deposit
        }), " "]
      })
    })]
  });
};

var BankingTable = function BankingTable(_ref2) {
  var data = _ref2.data,
      emi = _ref2.emi,
      description = _ref2.description,
      thead = _ref2.thead,
      props = (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref2, _excluded);

  var renderTbody = data.length > 0 && data.map(function (item, itemIdx) {
    return Array.isArray(item.banks) && item.banks.length > 0 && item.banks.map(function (tableItem, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("tr", {
        className: "".concat(itemIdx % 2 === 0 ? "bg-white" : "bg-bbc-brand-100", "  text-sm  leading-6"),
        children: [index == 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("td", {
          className: "pl-7 pr-6 font-medium leading-6 text-bbc-brand-800 ".concat(emi && " text-left", " "),
          rowSpan: item.banks.length,
          children: item.name
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("td", {
          className: " py-1.5 text-left",
          children: tableItem.name
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(TdBody, {
          tableItem: tableItem,
          emi: emi
        })]
      }, index);
    });
  });

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(function () {
    if ((0,common_lodash_keyExistsOn__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(data[0].banks[0], "other_features") || (0,common_lodash_keyExistsOn__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(data[0].banks[0], "initial_deposit")) return thead;
    return (0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(thead).slice(0, thead.length - 1);
  }),
      theadArr = _useState[0];

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
    className: props.className,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("div", {
      className: "overflow-hidden rounded-2xl border border-bbc-neutral-400  bg-white",
      style: {
        paddingBottom: (description === null || description === void 0 ? void 0 : description.length) > 0 ? "22px" : "0"
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)("table", {
        className: "w-full",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("thead", {
          className: "border-b ",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("tr", {
            children: theadArr.map(function (item, index) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("th", {
                className: "".concat(index === 0 && "pl-7", " ").concat(index < 2 && "text-left", "  p-3 text-sm font-medium leading-6 text-bbc-brand-700"),
                children: item
              }, index);
            })
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("tbody", {
          className: "",
          children: renderTbody
        })]
      }), (description === null || description === void 0 ? void 0 : description.length) > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
        className: "mt-4 px-7 text-sm leading-6",
        dangerouslySetInnerHTML: {
          __html: description
        }
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BankingTable);
BankingTable.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {})
};

/***/ }),

/***/ 25497:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ BankMobile; },
  "Z": function() { return /* binding */ organisms_BankingOptions; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaCheckCircle.js
var FaCheckCircle = __webpack_require__(59699);
// EXTERNAL MODULE: ./components/atoms/Icon/fa/FaTimesCircle.js
var FaTimesCircle = __webpack_require__(58787);
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
// EXTERNAL MODULE: ./common/hooks/useOnClickOutside.js
var useOnClickOutside = __webpack_require__(93615);
// EXTERNAL MODULE: ./components/atoms/Dropdown/index.js
var Dropdown = __webpack_require__(83719);
// EXTERNAL MODULE: ./components/atoms/Icon/fi/FiChevronDown.js
var FiChevronDown = __webpack_require__(49604);
// EXTERNAL MODULE: ./components/templates/hk/guide-and-tool/hong-kong-cost-planning-tool/step5/index.js + 2 modules
var step5 = __webpack_require__(38239);
// EXTERNAL MODULE: ./components/molecules/BankingMultiSelect/Index.module.scss
var Index_module = __webpack_require__(41249);
var Index_module_default = /*#__PURE__*/__webpack_require__.n(Index_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/molecules/BankingMultiSelect/index.js




/** ========== */










function Component() {
  var _useState = (0,react.useState)(false),
      isOpen = _useState[0],
      setIsOpen = _useState[1];

  var _useState2 = (0,react.useState)([]),
      selectedBanks = _useState2[0],
      setSelectedBanks = _useState2[1];

  var _useState3 = (0,react.useState)("All"),
      remoteOpening = _useState3[0],
      setRemoteOpening = _useState3[1];

  var _useState4 = (0,react.useState)("All"),
      amountOfInitialDeposit = _useState4[0],
      setAmountOfInitialDeposit = _useState4[1];

  var _useContext = (0,react.useContext)(contexts/* BankingOption */.ke),
      data = _useContext.data,
      setDataTable = _useContext.setDataTable;

  var _useState5 = (0,react.useState)(["All"].concat((0,toConsumableArray/* default */.Z)(data.map(function (item) {
    return item.name;
  })))),
      listCountry = _useState5[0];

  var multiSelectRef = (0,react.useRef)(null);
  /* Handle Event */

  function isSelected(value) {
    if (selectedBanks.find(function (el) {
      return el === value;
    })) {
      return true;
    }

    return false;
  }

  var generateLabelValueDropdown = function generateLabelValueDropdown(value) {
    if (value === "All") {
      return "Amount of initial Deposit";
    }

    if (value < 100001) {
      return "\u2264 US$".concat((0,step5/* formatNumber */.u)(value));
    }

    return "> US$100,000";
  };

  var remoteOpeningItem = function remoteOpeningItem(item) {
    if (item === "All") return "All";
    if (item < 100001) return "\u2264 US$".concat((0,step5/* formatNumber */.u)(item));
    return "> US$".concat((0,step5/* formatNumber */.u)(item - 1));
  };

  function handleDeselect(value) {
    if (value === "All") {
      setSelectedBanks([]);
    } else {
      var selectedBanksUpdated = selectedBanks.filter(function (el) {
        return el !== value;
      });

      if (selectedBanksUpdated.filter(function (el) {
        return el != "All";
      }).length === 0) {
        setSelectedBanks([]);
      } else {
        setSelectedBanks(selectedBanksUpdated.filter(function (el) {
          return el != "All";
        }));
      }
    }

    setIsOpen(true);
  }

  function handleSelect(value) {
    if (isSelected(value)) {
      handleDeselect(value);
    }

    if (!isSelected(value)) {
      if (value === "All") {
        setSelectedBanks(listCountry);
      } else {
        var selectedBanksUpdated = [].concat((0,toConsumableArray/* default */.Z)(selectedBanks), [listCountry.find(function (el) {
          return el === value;
        })]).sort(function (a, b) {
          return a.localeCompare(b);
        });

        if (JSON.stringify(selectedBanksUpdated) === JSON.stringify(listCountry.filter(function (el) {
          return el != "All";
        }).sort(function (a, b) {
          return a.localeCompare(b);
        }))) {
          setSelectedBanks(listCountry);
        } else {
          setSelectedBanks(selectedBanksUpdated);
        }
      }
    }

    setIsOpen(true);
  }

  function getResult() {
    var dataFilter = (0,toConsumableArray/* default */.Z)(data);

    if (remoteOpening === "Yes") {
      dataFilter = dataFilter && dataFilter.map(function (country) {
        return {
          id: country.id,
          name: country.name,
          banks: country.banks.filter(function (bank) {
            return bank.personal_visit === false;
          })
        };
      }).filter(function (item) {
        return item.banks.length > 0;
      });
    }

    if (selectedBanks.length > 0) {
      dataFilter = dataFilter.filter(function (bank) {
        return selectedBanks.includes(bank.name);
      });
    }

    if (parseInt(amountOfInitialDeposit, 10) <= 100000) {
      dataFilter = dataFilter.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          banks: item.banks.filter(function (e) {
            return parseInt(e.initial_deposit_usd, 10) <= parseInt(amountOfInitialDeposit, 10);
          })
        };
      });
    } else if (parseInt(amountOfInitialDeposit, 10) > 100000) {
      dataFilter = dataFilter.map(function (item) {
        return {
          id: item.id,
          name: item.name,
          banks: item.banks.filter(function (e) {
            return parseInt(e.initial_deposit_usd, 10) > parseInt(amountOfInitialDeposit, 10) - 1;
          })
        };
      });
    }

    return dataFilter;
  }
  /* Effect */


  (0,useOnClickOutside/* default */.Z)(multiSelectRef, function () {
    setIsOpen(false);
  });
  (0,react.useEffect)(function () {
    setDataTable(getResult()); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [remoteOpening, selectedBanks, amountOfInitialDeposit]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "row justify-between",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
        value: remoteOpening,
        labelValue: remoteOpening === "All" ? "Remote Opening" : remoteOpening,
        onChange: setRemoteOpening,
        activeIndex: "Remote Opening",
        className: "dropdown-default h-full w-full text-sm",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "shadow-bbc rounded-b-xl bg-white pb-2",
          children: ["All", "Yes"].map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
              value: item,
              as: "div",
              className: "block cursor-pointer",
              children: function children(_ref) {
                var active = _ref.active,
                    selected = _ref.selected;
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat(active && " rounded-md bg-bbc-brand-100", "   ").concat(selected && "font-semibold", "  block px-4 py-2  text-bbc-brand-800"),
                  children: item
                });
              }
            }, item);
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        ref: multiSelectRef,
        className: "".concat((Index_module_default()).MultiSelect, " shadow-bbc relative my-2 inline-block w-full rounded-xl bg-white py-3 text-left lg:my-0"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox */.Ri, {
          as: "div",
          className: "space-y-1",
          value: selectedBanks,
          onChange: function onChange(value) {
            return handleSelect(value);
          },
          open: isOpen,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              id: "banks-check-btn",
              onClick: function onClick() {
                return setIsOpen(!isOpen);
              },
              children: /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Listbox.Button */.Ri.Button, {
                className: "w-full select-none px-4  text-left text-sm ",
                open: isOpen,
                children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                  className: "truncate font-medium ",
                  children: selectedBanks.length < 1 ? "Bank Country" : "Bank Country: ".concat(selectedBanks.find(function (el) {
                    return el === "All";
                  }) ? selectedBanks.length - 1 : selectedBanks.length, " selected")
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(FiChevronDown/* FiChevronDown */.b, {
                  className: "float-right mt-1 inline-block align-middle text-bbc-brand-500   \n                                         ".concat(isOpen ? "rotate-180" : "rotate-0", " transition-all duration-200"),
                  size: 20
                })]
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Transition */.uT, {
              id: "banks-check-dropdown",
              unmount: true,
              show: isOpen,
              leave: "transition ease-in duration-100",
              leaveFrom: "opacity-100",
              leaveTo: "opacity-0",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Options */.Ri.Options, {
                "static": true,
                className: "shadow-b-bbc absolute z-50 w-full select-none rounded-b-xl bg-white pt-2 pb-2 text-sm",
                children: listCountry.map(function (person) {
                  var selected = isSelected(person);
                  return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
                    value: person,
                    children: function children(_ref2) {
                      var active = _ref2.active;
                      return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                        className: "".concat(selected ? "bg-bbc-brand-100 text-bbc-brand-700" : "text-bbc-brand-800", " relative cursor-pointer select-none py-2 pl-8 pr-4\n                              hover:bg-bbc-brand-100 hover:text-bbc-brand-700"),
                        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "".concat(selected ? "font-semibold " : "", " block truncate"),
                          children: person
                        }), selected && /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
                          className: "".concat(active ? "" : "text-bbc-brand-500", " absolute inset-y-0 left-0 flex items-center pl-1.5"),
                          children: /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
                            className: "h-5 w-5",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
                              fillRule: "evenodd",
                              d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
                              clipRule: "evenodd"
                            })
                          })
                        })]
                      });
                    }
                  }, person);
                })
              })
            })]
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "col-12 lg:col-4",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
        value: amountOfInitialDeposit,
        labelValue: amountOfInitialDeposit && generateLabelValueDropdown(amountOfInitialDeposit),
        onChange: setAmountOfInitialDeposit,
        activeIndex: "Amount of initial Deposit",
        className: "dropdown-default h-full w-full text-sm",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "shadow-bbc rounded-b-xl bg-white pb-2",
          children: ["All", 10000, 50000, 100000, 100001].map(function (item) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Listbox.Option */.Ri.Option, {
              value: item,
              as: "div",
              className: "block cursor-pointer",
              children: function children(_ref3) {
                var active = _ref3.active,
                    selected = _ref3.selected;
                return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                  className: "".concat(active && " rounded-md bg-bbc-brand-100", " ").concat(selected && "font-semibold", " block px-4 py-2 text-bbc-brand-800"),
                  children: remoteOpeningItem(item)
                });
              }
            }, item);
          })
        })
      })
    })]
  });
}

/* harmony default export */ var BankingMultiSelect = (Component);
Component.defaultProps = {
  data: [],
  children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
};
// EXTERNAL MODULE: ./components/molecules/BankingTable/index.js
var BankingTable = __webpack_require__(43200);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
;// CONCATENATED MODULE: ./components/organisms/BankingOptions/index.js













var BankCard = function BankCard(_ref) {
  var bank = _ref.bank,
      thead = _ref.thead;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "mt-2 rounded-3xl bg-white py-6 px-5",
    style: {
      boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)"
    },
    children: bank.contact_us ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-5 text-xl font-bold tracking-[0.15px] text-bbc-black",
        children: bank.name
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Contact us for details"
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "mb-5 text-xl font-bold tracking-[0.15px] text-bbc-black",
        children: bank.name
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-2.5 flex items-center",
        children: [bank.online_banking || bank.online_registration ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
          className: "mr-2.5 text-bbc-brand-600",
          size: 16
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimesCircle/* FaTimesCircle */.G, {
          className: "mr-2.5 text-bbc-red-400",
          size: 16
        }), thead[2]]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-2.5 flex items-center",
        children: [bank.personal_visit || bank.multiple_account ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
          className: "mr-2.5 text-bbc-brand-600",
          size: 16
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimesCircle/* FaTimesCircle */.G, {
          className: "mr-2.5 text-bbc-red-400",
          size: 16
        }), thead[3]]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "mb-2.5 flex items-center",
        children: [bank.credit_card || bank.support_transactions ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
          className: "mr-2.5 text-bbc-brand-600",
          size: 16
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimesCircle/* FaTimesCircle */.G, {
          className: "mr-2.5 text-bbc-red-400",
          size: 16
        }), thead[4]]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex items-center ".concat((bank.initial_deposit || bank.other_features) && "mb-5 pb-4", "  "),
        children: [bank.debit_card || bank.physical_card ? /*#__PURE__*/(0,jsx_runtime.jsx)(FaCheckCircle/* FaCheckCircle */.F, {
          className: "mr-2.5 text-bbc-brand-600",
          size: 16
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(FaTimesCircle/* FaTimesCircle */.G, {
          className: "mr-2.5 text-bbc-red-400",
          size: 16
        }), thead[5]]
      }), (bank.initial_deposit || bank.other_features) && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "mb-3.5 border-t border-t-[#797979]",
          children: thead[6]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          children: bank.initial_deposit || bank.other_features
        })]
      })]
    })
  });
};

var BankMobile = function BankMobile(_ref2) {
  var data = _ref2.data,
      thead = _ref2.thead;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: data.length < 2 ? data[0].banks.map(function (bank, bankIdx) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(BankCard, {
        bank: bank,
        thead: thead
      }, bankIdx);
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
      data: data.map(function (item) {
        return item.name;
      }),
      tabListClass: {
        length: "w-full",
        border: "border-0",
        display: data.length > 2 ? "flex justify-start" : "flex justify-center",
        padding: "px-2 py-1.5",
        othersClass: "whitespace-nowrap overflow-x-auto"
      },
      tabClass: {
        tabColor: "text-bbc-brand-800 border-transparent",
        padding: "px-6 py-2"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
        className: "mt-6",
        children: data.map(function (country, idx) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
            className: "focus:outline-none focus:outline-0 focus:ring-0",
            as: "div",
            children: country.banks.map(function (bank, bankIdx) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(BankCard, {
                bank: bank,
                thead: thead
              }, bankIdx);
            })
          }, idx);
        })
      })
    })
  });
};
var traditionalThead = ["Country", "Bank", "Online Banking", "Personal Visit", "Credit Card", "Debit Card", "Initial Deposit"];
var emiThead = ["Country", "EMI", "Online registration", "Multiple currency business account", "Support international transactions", "Physical card", "Other features"];

var BankingOptions = function BankingOptions(_ref3) {
  var dataTraditional = _ref3.dataTraditional,
      dataEMI = _ref3.dataEMI,
      title = _ref3.title,
      description = _ref3.description,
      noteTraditional = _ref3.noteTraditional,
      noteEMI = _ref3.noteEMI,
      hideNote = _ref3.hideNote,
      noSelect = _ref3.noSelect,
      tabArray = _ref3.tabArray;

  var _useState = (0,react.useState)(dataTraditional),
      dataTable = _useState[0],
      setDataTable = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex justify-center ",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(TabListNew/* default */.Z, {
        data: tabArray,
        tabListClass: tabArray.length > 1 ? {
          background: "bg-white"
        } : {
          background: "bg-white",
          display: "hidden"
        },
        children: [tabArray.includes("Traditional Bank") && /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
          className: "focus:outline-none focus:outline-0 focus:ring-0",
          as: "div",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "my-6 pb-0 text-center text-2xl font-semibold leading-[44px] text-bbc-brand-800 md:my-8 md:text-3xl",
            children: title
          }), description && /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "mb-10 text-center md:mb-8 md:text-left",
            children: description
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(contexts/* BankingOption.Provider */.ke.Provider, {
            value: {
              data: dataTraditional,
              dataTable: dataTable,
              setDataTable: setDataTable
            },
            children: [!noSelect && /*#__PURE__*/(0,jsx_runtime.jsx)(BankingMultiSelect, {}), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "hidden md:block",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankingTable/* default */.Z, {
                hideNote: hideNote,
                data: dataTable,
                className: "mt-4",
                thead: traditionalThead,
                description: noteTraditional
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "mt-6 block md:hidden ",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankMobile, {
                data: dataTable,
                thead: traditionalThead
              })
            })]
          })]
        }, "traditional-bank"), tabArray.includes("EMI") && /*#__PURE__*/(0,jsx_runtime.jsxs)(headlessui_esm/* Tab.Panel */.OK.Panel, {
          className: "focus:outline-none focus:outline-0 focus:ring-0",
          as: "div",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
            className: "my-10 pb-0 text-center text-2xl font-semibold leading-[44px] text-bbc-brand-800 md:my-8 md:text-3xl",
            children: "Electronic Money Institutions"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "text-center md:text-left",
            children: "In case you struggle in opening your business account in traditional banks, there is an alternative solution - Electronic Money Institution (EMI). EMIs are financial institutions that provide similar bank-like services and payment-related functions such as e-wallets, payments cards, or IBAN accounts. Here are the top EMIs you can consider."
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "hidden md:block",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankingTable/* default */.Z, {
              hideNote: hideNote,
              data: dataEMI,
              emi: true,
              thead: emiThead,
              className: "mt-4",
              description: noteEMI
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "mt-6  block md:hidden ",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BankMobile, {
              data: dataEMI,
              thead: emiThead
            })
          })]
        }, "electronic-money-institutions")]
      })
    })
  });
};

/* harmony default export */ var organisms_BankingOptions = (BankingOptions);
BankingOptions.defaultProps = {
  data: [],
  tabArray: ["Traditional Bank", "EMI"]
};

/***/ }),

/***/ 95183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(30266);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(809);
/* harmony import */ var _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30852);
/* harmony import */ var components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97464);
/* harmony import */ var components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27597);
/* harmony import */ var components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31741);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85893);







/** ========== */




var RequiredDocument = function RequiredDocument(_ref) {
  var _data$content;

  var title = _ref.title,
      data = _ref.data,
      sectionClassName = _ref.sectionClassName,
      backgroundImage = _ref.backgroundImage;
  var checkBtnRight = data.button_image && Object.keys(data.button_image).length > 0;

  var renderButton = function renderButton() {
    var button = data.button;

    if (button) {
      if (button.type === "contact-us") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6 text-center lg:text-left",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: button.link,
            className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
            children: button.text
          })
        });
      }

      if (button.type === "talk-to") {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "mt-6",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_ButtonNew_index__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            as: "button",
            onClick: /*#__PURE__*/(0,_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)( /*#__PURE__*/_codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
              return _codebuild_output_src487379062_src_bitbucket_org_sunbrightvn_nextjs_bbcincorp_template_v2_node_modules_next_node_modules_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 3;
                      return Tawk_API.toggle();

                    case 3:
                      _context.next = 8;
                      break;

                    case 5:
                      _context.prev = 5;
                      _context.t0 = _context["catch"](0);
                      console.error();

                    case 8:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee, null, [[0, 5]]);
            })),
            children: button.text
          })
        });
      }

      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
        className: "mt-6 text-center lg:text-left",
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
          href: button.link,
          className: "inline-block rounded-[50px] px-6 py-2 text-white transition-all hover:bg-bbc-brand-600 ".concat(button.noBackground ? "border border-white font-medium hover:border-bbc-brand-600" : "bg-bbc-primary font-semibold"),
          children: button.text
        })
      });
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
    className: "relative ".concat(sectionClassName ? sectionClassName : "bg-bbc-brand-800 py-[50px]"),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
      className: "container relative z-10",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
        className: "row",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("div", {
          className: "".concat(checkBtnRight ? "lg:col-8" : "lg:col-12"),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Title__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            as: "h2",
            text: title,
            className: "mb-6 text-center text-bbc-30px font-semibold capitalize text-white lg:text-left lg:text-bbc-40px"
          }), (data === null || data === void 0 ? void 0 : (_data$content = data.content) === null || _data$content === void 0 ? void 0 : _data$content.length) > 0 && data.content.map(function (item, index) {
            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
              children: [item.title && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                className: "mb-2 text-white ",
                dangerouslySetInnerHTML: {
                  __html: item.title
                }
              }), item.listContent && item.listContent.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                className: "lg:mb-2",
                children: item.listContent.map(function (element, i) {
                  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("li", {
                    className: "   relative mb-2 pl-[22px] text-white before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1.5 before:w-1.5 before:rounded-full before:bg-bbc-secondary-100 before:content-['']",
                    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
                      dangerouslySetInnerHTML: {
                        __html: element.text
                      }
                    }), element.content && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("ul", {
                      children: element.content.map(function (element, index) {
                        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("li", {
                          className: "relative mb-2 pl-[22px] text-white  before:absolute before:top-2.5 before:left-[5px] before:inline-block before:h-1 before:w-1 before:rounded-full before:bg-white before:content-['']",
                          children: element
                        }, index);
                      })
                    })]
                  }, i);
                })
              })]
            }, index);
          }), (data === null || data === void 0 ? void 0 : data.note) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("p", {
            className: "m-0 text-white",
            dangerouslySetInnerHTML: {
              __html: data.note
            }
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
            className: "text-center lg:text-left",
            children: renderButton()
          })]
        }), checkBtnRight && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", {
          className: "lg:col-4",
          children: data.button_image.type && data.button_image.type === "post" ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("a", {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noopener noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: data.button_image.width || 350,
              height: data.button_image.height || 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_LinkRouter__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            href: data.button_image.uri,
            target: "_blank",
            rel: "noreferrer",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
              src: data.button_image.src,
              alt: data.button_image.alt,
              width: 350,
              height: 350,
              className: "transition-all duration-200 hover:scale-105",
              wrapper: {
                className: "mt-6 lg-mt:0 w-full h-full z-0 flex justify-center items-center"
              }
            })
          })
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(components_atoms_Img__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
      src: backgroundImage,
      width: 1920,
      height: 737,
      className: "h-full w-full",
      wrapper: {
        className: "absolute top-0 left-0 w-full h-full z-0"
      }
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (RequiredDocument);
RequiredDocument.defaultProps = {
  title: "",
  data: {},
  sectionClassName: ""
};
/** ========== */

/***/ }),

/***/ 41249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"MultiSelect":"Index_MultiSelect__Mtpi5"};

/***/ })

}]);